import { useState, useRef } from "react";
import { Box, IconButton, Button, Spinner, HStack, Text } from "@chakra-ui/react";
import { FiLogOut } from "react-icons/fi";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";

const AlertDialogModel = ({
  title,
  description,
  btnName,
  isOpen,
  onClose,
  handleForAction,
  waveflowResetLoder
}) => {
  const cancelRef = useRef();
  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {title}
            </AlertDialogHeader>

            <AlertDialogBody>{description}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleForAction} ml={3}>
                <HStack spacing={2}>
                  <Text color={"white"}>{btnName}</Text>
                  {btnName=="Reset" && waveflowResetLoder && <Spinner />}
                </HStack>
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AlertDialogModel;
